<script setup lang="ts">
import useFetch from './useFetch'

const route = useRoute()

const { checkHasParams, confirmNewEmail } = useFetch()
const { isMobile } = useDevice()

checkHasParams()
</script>

<template>
  <a-row
    :gutter="32"
    class="reset-email__wrapper"
    :class="isMobile ? 'mobile' : null"
  >
    <a-col :span="24" :sm="{ span: 24 }" :md="{ span: 12 }">
      <div class="reset-email__info">
        <div class="info-title">Konfirmasi Perubahan Email</div>
        <div class="info-detail">
          Kami menerima permohonan perubahan email akun Kognisi. <br />
          <div class="mb-4">
            <span class="info-detail__email">{{ route.query?.oldEmail }}</span>
            menjadi
            <span class="info-detail__email">{{ route.query?.newEmail }}</span>
          </div>
          Untuk menyelesaikan proses pergantian email, silahkan melakukan
          konfirmasi dengan klik tombol dibawah ini
        </div>
        <a-button type="primary" block @click="confirmNewEmail">
          Konfirmasi
        </a-button>
      </div>
    </a-col>
  </a-row>
</template>

<style lang="scss">
@use './styles.scss';
</style>
